import { spaceResearch } from "../_MOD/space-researches/spaceResearches"
export const space = {
    spaceResearch,
}